import BasePage from "../../BasePage";
import Loader from "../../../components/loaders";
import React, { useCallback, useState } from "react";
import Pagination from "@material-ui/lab/Pagination/Pagination";
import { ControlledTextfield } from "../../../components/inputs";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { Add, SearchOutlined } from "@material-ui/icons";
import Organizacao from "./Organizacao";
import FormOrganizacao from "./FormOrganizacao.connected";
import ConfirmarExclusaoDialog from "./ConfirmarExcluaoDialog";

const OrganizacaoPage = ({
  organizacoes,
  organizacao,
  loading,
  total,
  pagina,
  tipoOrganizacao,
  handlePagination,
  handleSearch,
  formProps,
  handleNew,
  handleEdit,
  handleDelete,
}) => {
  const handleClick = useCallback(
    (values) => {
      handleSearch(values);
    },
    [handleSearch]
  );

  const [dadosExclusaoOrganizacao, setDadosExclusaoOrganizacao] = useState({
    open: false,
  });

  const handleCloseExclusaoOrganizacao = useCallback(() => {
    setDadosExclusaoOrganizacao({
      open: false,
    });
  }, []);

  const handleOpenExclusaoOrganizacao = useCallback((values) => {
    setDadosExclusaoOrganizacao({
      open: true,
      organizacao: values,
    });
  }, []);

  return (
    <BasePage isLoggedIn={true}>
      {!!loading && (
        <div className="row spacer">
          <div className="col-12 d-flex justify-content-center">
            <Loader type={"dots"} color={"brand"} size={80} />
          </div>
        </div>
      )}
      {!loading && !organizacao && (
        <div className="row spacer">
          <div className="col-12">
            <div className="card" style={{ minHeight: 100 }}>
              <div className="card-body d-flex flex-column">
                <div className={"row d-flex align-items-center"}>
                  <div className={"col mt-0"}>
                    <div className="card-title color-brand">Organizações</div>
                  </div>
                  <div className="d-none d-md-block mb-4">
                    <form onSubmit={formProps.handleSubmit(handleClick)}>
                      <ControlledTextfield
                        variant={"standard"}
                        search={true}
                        name={"search"}
                        formProps={formProps}
                        uppercase={false}
                        label={"Pesquisar"}
                        margin={"none"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="search"
                                edge="end"
                                type={"submit"}
                              >
                                <SearchOutlined />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </form>
                  </div>
                </div>
                <div className={"row spacer"}>
                  <div className="col-3 col-md-3 mt-sm-2 mt-lg-0 color-brand">
                    <span>ORGANIZAÇÃO</span>
                  </div>
                  <div className="col-6 col-md-6 my-2 my-lg-0 color-brand">
                    <span>NOME</span>
                  </div>
                  <div className="col-2 col-md-2  my-2 my-lg-0 color-brand">
                    <span>TIPO</span>
                  </div>
                </div>
                <div className={"row"}>
                  <div className="col-12">
                    {organizacoes.map((d, index) => (
                      <Organizacao
                        key={d.id}
                        organizacao={d}
                        index={index}
                        tipoOrganizacao={tipoOrganizacao}
                        handleEdit={handleEdit}
                        handleOpenExclusaoOrganizacao={
                          handleOpenExclusaoOrganizacao
                        }
                      />
                    ))}
                  </div>
                </div>
                <div className="row spacer">
                  <div className="col-12 offset-md-8 col-md-4">
                    <div className="d-none d-md-block">
                      <div className="botao-adicionar mr-3" onClick={handleNew}>
                        <Add className="botao-adicionar-icon mr-1" />
                        <span className="botao-adicionar-text">
                          ADICIONAR ORGANIZAÇÂO
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {!loading && !organizacao && total > 10 && (
        <>
          <div className="row spacer">
            <div className="col-12">
              <Pagination
                count={Math.ceil(total / 10)}
                page={pagina}
                variant="outlined"
                shape="rounded"
                onChange={handlePagination}
              />
            </div>
          </div>
        </>
      )}
      {!loading && !!organizacao && (
        <div>
          <FormOrganizacao tipoOrganizacao={tipoOrganizacao} />
        </div>
      )}
      <ConfirmarExclusaoDialog
        open={dadosExclusaoOrganizacao.open}
        handleClose={handleCloseExclusaoOrganizacao}
        excluirPerfil={handleDelete}
        organizacao={dadosExclusaoOrganizacao.organizacao}
      />
    </BasePage>
  );
};

export default OrganizacaoPage;
